import { render } from "./ComparisonSection.vue?vue&type=template&id=bc2a66c8&scoped=true"
import script from "./ComparisonSection.vue?vue&type=script&lang=js"
export * from "./ComparisonSection.vue?vue&type=script&lang=js"

import "./ComparisonSection.vue?vue&type=style&index=0&id=bc2a66c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc2a66c8"]])

export default __exports__